<template>
  <div class="main">
    <report-top>
      <ly-search slot="search" v-model="searchItem.keyword" @search="search"></ly-search></report-top>
    <selectTool ref="selectTool"><template slot="btn"><Button @click="getSearchItem" type="error"
          class="chaxun">查询</Button></template>
    </selectTool>

    <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)">
      <template slot-scope="{ row, index }" slot="nodeName">
        <a @click="openNode(row)">{{ row.nodeName }}</a>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="openChuli(row)">处理</Button>
        <Button size="small" @click="openBackFormFun(row)">退回</Button>
        <Button size="small" @click="openJincheng(row)">进程</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
    <Modal v-model="openForm" title="请按照以下步骤处理" footer-hide width="1000">
      <docDetail ref="docDetail">

      </docDetail>
      <div>
        <Button v-for="(y, index1) in steps[1].btns" :key="index1" type="success" @click="clickBtn(y, index1)"
          style="margin-right: 6px">{{ y.name }}</Button>
        <Button @click="openFlowFun" type="primary">流程提交</Button>
      </div>
    </Modal>
    <Modal v-model="openFlowForm" :title="isFinish ? '流程办结' : '流程提交给下一处理人'" footer-hide width="700">
      <Form ref="item" :model="item" :rules="ruleValidate" :label-width="90">
        <Row :gutter="16">
          <Col span="12">
          <FormItem label="当前节点" prop="nodeName">
            <Input v-model="item.nodeName" readonly placeholder="请输入"></Input>
          </FormItem>
          </Col>
          <Col span="12" v-if="!isFinish">
          <FormItem label="下个节点" prop="nextNodeName">
            <Input v-model="item.nextNodeName" readonly placeholder="请输入"></Input>
          </FormItem>
          </Col>
          <Col span="12" v-if="!isFinish">
          <FormItem label="待办人" prop="auditorUser1">
            <Input v-model="item.auditorUser1" readonly placeholder="请输入"></Input>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="处理意见" prop="content">
            <Input v-model="item.content" placeholder="请输入"></Input>
          </FormItem>
          </Col>
          <Col span="24">
          <FormItem label="处理图片" prop="afterImgList">
            <ly-photo ref="lyphoto" v-model="item.afterImgList"></ly-photo>
          </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Col span="24">
          <div class="btn-wrap">
            <Button type="primary" @click="chuli('item')">提交处理</Button>
          </div>
          </Col>
        </Row>
      </Form>
    </Modal>
    <Modal v-model="openBackForm" title="退回处理" footer-hide width="400" height="400">
      <Form ref="backItem" :model="backItem" :rules="ruleValidate" :label-width="80">
        <Row :gutter="16">
          <Col span="24">
          <FormItem label="处理意见" prop="content">
            <Input v-model="backItem.content" placeholder="请输入"></Input>
          </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Col span="24">
          <div class="btn-wrap">
            <Button type="primary" @click="backNode('backItem')">提交处理</Button>
          </div>
          </Col>
        </Row>
      </Form>
    </Modal>
    <jincheng ref="jincheng"></jincheng>
    <qianzi ref="qianzi" @ok="reOk"></qianzi>
    <nowNoName ref="nowNoName"></nowNoName>

  </div>
</template>
<script>
import jincheng from "./jincheng.vue";
import docDetail from "./docDetail.vue";
import rule from "./rule";
import qianzi from "./qianzi.vue";
import nowNoName from "./nowNoName.vue";
var flows = [];
export default {
  components: {
    jincheng,
    docDetail,
    qianzi,
    nowNoName,
  },
  data() {
    return {
      openForm: false,
      openBackForm: false,
      openFlowForm: false,
      value: "2",
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "流水号",
          key: "title",
        },
        {
          title: "流程名称",
          key: "flowName",
        },
        {
          title: "当前节点",
          slot: "nodeName",
        },
        {
          title: "提交人",
          key: "addUser",
        },
        {
          title: "提交意见",
          key: "remark",
        },
        {
          title: "状态标签",
          key: "stateLable",
        },
        {
          title: "待办人",
          key: "auditorUser",
        },
        {
          title: "创建时间",
          key: "createTime2",
        },
        {
          title: "操作",
          slot: "action",
          width: 150,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        flowStartId: "", //流程实例ID
        nodeId: "", //当前节点ID
        nodeName: "",
        nextNodeId: "", //下个节点id
        nextNodeName: "",
        auditorUserid: [], //处理用户账号列表
        auditorUser: [],
        content: "",
        beforeImg: "",
        beforeImgList: [],
        afterImg: "",
        afterImgList: [],
        filePath: "",
      },
      backItem: {
        flowStartId: "",
        content: "",
      },
      banjieItem: {
        flowStartId: "",
        content: "",
        beforeImg: "",
        afterImg: "",
        filePath: "",
      },

      ruleValidate: {
        name: { required: true, message: "必填" },
        content: { required: true, message: "必填" },
      },
      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
        startDate: 0,
        endDate: 0,
      },
      total: 0,
      categorys: [],
      isFinish: false,
      selectItems: [],
      steps: [
        {
          name: "审阅材料",
          btns: [],
          icon: "md-eye",
        },
        {
          name: "填写材料",
          btns: [],
          icon: "ios-open",
        },
        {
          name: "流程处理",
          btns: [
            {
              name: "现在处理",
              type: "flow",
            },
          ],
          icon: "md-checkmark-circle",
        },
      ],
      current: 2,
      searchForms: [
        {
          title: "选择流程",
          key: "flowId",
          type: "Select",
          selectType: 'obj',
          selectItems: flows,
          times: "2,0",
        }, {
          title: "时间范围",
          key: "startDate",
          key1: "endDate",
          type: "lyyymmdd",
          times: "2,0",
        },
      ]
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.flow + "/flow/pendingList",
        data: this.searchItem,
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].nextNodeId = "";
          data[i].nextNodeName = "";
          data[i].beforeImg = "";
          data[i].beforeImgList = [];
          data[i].afterImg = "";
          data[i].afterImgList = [];
          data[i].content = "同意";
          data[i].createTime2 = this.utils.time(data[i].createTime);
        }
        this.tableData = data;
      });
    },
    openChuli(row) {
      this.openForm = true;
      this.item = row;
      this.current = 0;
      this.getNextNode(3);
      this.$refs.docDetail.reach(this.item);
    },
    chuli(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.item.beforeImg = this.item.beforeImgList.join(",");
          this.item.afterImg = this.item.afterImgList.join(",");
          if (this.isFinish) {
            this.axios({
              method: "post",
              url: this.axios.flow + "/flow/finish",
              data: this.item,
            }).then((res) => {
              if (res) {
                this.openFlowForm = false;
                this.openForm = false;
                this.getList();
              }
            });
          } else {
            this.axios({
              method: "post",
              url: this.axios.flow + "/flow/nextProcess",
              data: this.item,
            }).then((res) => {
              if (res) {
                this.openFlowForm = false;
                this.openForm = false;
                this.getList();
              }
            });
          }
        } else {
          return 123;
        }
      });
    },
    check(name) {
      this.cc = false;
      this.$refs[name].validate((valid) => {
        this.cc = valid;
      });
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      console.log(this.searchItem);
      this.searchItem.startDate = this.searchItem.startTime;
      this.searchItem.endDate = this.searchItem.endTime;
      this.getList();
    },
    getNextNode(type) {
      this.isFinish = false;
      //https://cloud.ly-gps.com/cloud-rmm-server-dpm/urgent
      //https://cloud.ly-gps.com/cloud-rmm-server-dpm/repair
      this.utils.loading(this, "加载中");
      var can = {
        flowId: this.item.flowId,
        nodeId: this.item.nodeId,
        nodeType: type ? type : 1, //0-开始节点(新建时指定),1-中间节点,2-结束节点
      };
      this.axios({
        method: "post",
        url: this.axios.flow + "/flow/nextNode",
        data: can,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;
        if (type == 3) {
          this.openRecordForm = true;

          var rule123 = data.rule;
          if (this.utils.isEmpty(rule123)) {
            rule123 = "empty";
          }

          var arb = rule123.split(",");
          this.steps[1].btns = [];
          for (const i in arb) {
            this.steps[1].btns.push(rule[arb[i]]);
          }
        } else {
          this.openForm = true;
          this.item.nextNodeId = data.id;
          this.item.nextNodeName = data.name;
          this.item.auditorUserid = [];
          this.item.auditorUser = [];
          var rule123 = data.rule;
          if (rule123 == "jiedan") {
            var m = this.$refs.docDetail.readDetail();
            console.log(m);

            this.item.auditorUserid = [m.driverAccountId];
            this.item.auditorUser = [m.driverName];
          } else {
            for (const i in data.user) {
              this.item.auditorUserid.push(data.user[i].accountId);
              this.item.auditorUser.push(data.user[i].name);
            }
          }

          if (data.id == "E002") {
            this.isFinish = true;
          }
          this.item.auditorUser1 = this.item.auditorUser.join("/");
        }
      });
    },
    openBackFormFun(row) {
      this.openBackForm = true;
      this.backItem.flowStartId = row.flowStartId;
    },
    backNode() {
      this.axios({
        method: "post",
        url: this.axios.flow + "/flow/backProcess",
        data: this.backItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        console.log(res);
        if (res) {
          this.openBackForm = false;
          this.getList();
        }
      });
    },
    openFlowFun() {
      this.openFlowForm = true;
      this.getNextNode();
    },
    openJincheng(row) {
      this.$refs.jincheng.reach(row);
    },
    clickBtn(y, index) {
      this.isLastBtn = false;
      if (this.steps[1].btns.length - 1 == index) {
        this.isLastBtn = true;
      }
      var obj = {
        docId: this.item.docId,
        name: y.name || 111,
        key: y.key || 222,
        type: y.type || 333,
        title: this.item.title,
        nodeName: this.item.nodeName,
        formId: this.item.formId,
      };
      if (y.type == "mainForm") {
        this.$refs.docDetail.reach(this.item);
      } else if (y.type == "flow") {
        this.openFlowForm = true;
        this.getNextNode();
      } else if (y.type == "table") {
        this.$refs[y.key + "List"].reach(obj);
      } else {
        this.$refs[y.key].reach(obj);
      }
    },
    openNode(v) {
      this.$refs.nowNoName.reach(v);
    },
    reOk() {
      this.$refs.docDetail.reach(this.item);
      if (this.isLastBtn) {
        this.openFlowFun();
      }
    },
    getFlows() {
      this.axios({
        method: "post",
        url: this.axios.flow + "/flowConfig/list",
        data: {},
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        flows.length=0;
  
        for (let i = 0; i < data.length; i++) {
          var obj={
            id:data[i].id,
            name:data[i].name
          }
          flows.push(obj)
        }
      });
    },
  },
  mounted() {
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
    this.getFlows();
  },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/wuliu/caiwufeiyong/daibanshenpi.vue